/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

export const paginationMeta2TotalMin = 0;

export const PaginationMeta2 = zod
  .object({
    total: zod.int().min(paginationMeta2TotalMin).describe("Total matching items."),
    page: zod.int().min(1).describe("Current 1-indexed page."),
    perPage: zod.int().min(1).describe("Requested items per page."),
  })
  .describe("Metadata for a paginated collection.");

export type PaginationMeta2 = zod.input<typeof PaginationMeta2>;
export type PaginationMeta2Output = zod.output<typeof PaginationMeta2>;
